type Rule<T> = {
  validator: T
  field: string
  fullField: string
  type: string
}

type AsyncValidator<T> = (
  rule: Rule<AsyncValidator<T>>,
  value: T
) => Promise<void>

type Validator<T> = (
  rule: Rule<Validator<T>>,
  value: T,
  callback: (e?: Error) => void
) => void

/**
 * This is a NOOP
 * @param validator
 */
export function createValidator<T = string>(
  validator: AsyncValidator<T>
): AsyncValidator<T>

/**
 * This is a NOOP
 * @param validator
 */
export function createValidator<T = string>(
  validator: Validator<T>
): Validator<T>

export function createValidator(validator: any) {
  return validator
}
